import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getDeliveryQrCode = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/delivery-qrcode',
    headers: getHeaders(),
  });
};
